import { MetaDefinition } from '@angular/platform-browser';
import { noIndexMetaTag } from '../../lib/meta-helpers';

export const simpleNoIndexMetaResolver = (): { tags: MetaDefinition[] } => {
  return {
    tags: [noIndexMetaTag],
  };
};
